module.exports = __webpack_public_path__ + "media/app/images/windows-bckg-b683c4a6861cd3deaa23ac584f0e7794.png";